import { DebuggerManager } from "@/stores/DebuggerManager";
import { XIcon } from "lucide-react";
import { observer } from "mobx-react-lite";

export interface ChecklistListModalProps {
  manager: DebuggerManager;
  isVisible: boolean;
  onClose: () => void;
}

export const ChecklistListModal = observer(({ manager, isVisible, onClose }: ChecklistListModalProps) => {
  function toTitleCase(str: string) {
    return str.replace(/\w\S*/g, (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase());
  }

  function replaceAll(str: string, find: string, replace: string) {
    return str.replace(new RegExp(find, "g"), replace);
  }

  const formatTitle = (title: string | null) => (!!title && title !== "" ? title : "Untitled");
  const formatStatus = (status: string | null) =>
    !!status && status !== "" ? toTitleCase(replaceAll(status, "_", " ")) : "Unknown";

  const isRunning = (checklistId: string) => manager.runningChecklist?.id === checklistId;

  return (
    <div className={`pyne-debugger-v2__guides-modal-container ${isVisible ? "visible" : "invisible"}`}>
      <div className="pyne-debugger-v2__guides-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="pyne-debugger-v2__guides-modal-header">
          <h2>Checklists</h2>
          <button className="close-button" onClick={onClose}>
            <XIcon style={{ width: 20, height: 20 }} />
          </button>
        </div>
        <div className="pyne-debugger-v2__guides-modal-body">
          <div className="pyne-debugger-v2__guide-list">
            {manager.checklists.map((checklist) => {
              return (
                <div
                  key={checklist.id}
                  className="pyne-debugger-v2__guide-item"
                  onClick={() => {
                    // manager.selectGuide(checklist.id);
                  }}
                >
                  <div className="pyne-debugger-v2__guide-name">{formatTitle(checklist.name)}</div>{" "}
                  <div className={`pyne-debugger-v2__guide-status ${isRunning(checklist.id) ? "running" : ""}`}>
                    {isRunning(checklist.id)
                      ? "Running"
                      : formatStatus(manager.getChecklistEvaluationStatus(checklist.id))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
});
